let baseClassName = 'elevio__';
export function setBaseClassName(base) {
    baseClassName = base;
}
export function addClassName(name) {
    return `${baseClassName}${name}`;
}
//# sourceMappingURL=classes.js.map